import { render, staticRenderFns } from "./DeviceDescription.vue?vue&type=template&id=63391f93"
import script from "./DeviceDescription.vue?vue&type=script&lang=ts"
export * from "./DeviceDescription.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports